import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import Slider from 'rc-slider';

import sitting from '../../../../resources/img/sad_icon.svg';
import walking from '../../../../resources/img/meh_icon.svg';
import running from '../../../../resources/img/happy_icon.svg';

import '../SignUpNew.css';
import 'rc-slider/assets/index.css';

class PageSixPers extends Component {

  render() {
    const {
      handleButtonClick,
      selectedMotivation,
      motivationOptions,
      setSelectedMotivation
    } = this.props;

    const { skipValidation } = this.props;
    const valid = motivationOptions.includes(selectedMotivation);

    const onSliderChange = (v) => {
      const level = motivationOptions[v - 1]
      if (level)
        setSelectedMotivation(level);
    };

    const setmarks = {
      1: {
        style: {
          fontSize: '16px',
          lineHeight: '19px',
          textAlign: 'center',
          marginTop: '30px',
          fontWeight: selectedMotivation.id === 1 ? 'bold' : 'normal',
        },
        label: (
          <div>
            <div className="pers-colour-dark-text">1</div>
            <div className="slider-label">{motivationOptions[0].level}</div>
            <div style={{textAlign: 'center'}}>
              <img src={sitting} className="sitting-man" alt="sitting icon" />
            </div>
          </div>
        )
      },
      2: {
        style: {
          fontSize: '16px',
          lineHeight: '19px',
          textAlign: 'center',
          marginTop: '30px',
          fontWeight: selectedMotivation.id === 2 ? 'bold' : 'normal'
        },
        label: (
          <div>
            <div className="pers-colour-dark-text">2</div>
            <div className="slider-label">{motivationOptions[1].level}</div>
            <div style={{textAlign: 'center'}}>
              <img src={walking} className="walking-man" alt="walking icon" />
            </div>
          </div>
        )
      },
      3: {
        style: {
          fontSize: '16px',
          lineHeight: '19px',
          textAlign: 'center',
          marginTop: '30px',
          fontWeight: selectedMotivation.id === 3 ? 'bold' : 'normal'
        },
        label: (
          <div>
            <div className="pers-colour-dark-text">3</div>
            <div className="slider-label">{motivationOptions[2].level}</div>
            <div style={{textAlign: 'center'}}>
              <img src={running} className="running-man" alt="running icon" />
            </div>
          </div>
        )
      }
    };

    return (
      <div className="no-padding" style={{ padding: "0 2em" }}>
        <div className="title-section">
          <div>
            <p className="hlayout-title">
              How motivated are you to be physically active?
            </p>
          </div>

          <div>
            <p className="hlayout-copy">
              This information helps us match you with organisations and resources that can help you achieve your goals.            </p>
          </div>
        </div>

        <div className="hlayout-bottom no-colour row">
          <div className="col-md-2 no-padding" />

          <div className="col-md-8 mb-20 mt-20">
            <Slider
              min={1}
              max={3}
              value={motivationOptions.indexOf(selectedMotivation) + 1}
              onChange={(v) => onSliderChange(v)}
              marks={setmarks}
              step={1}
              included={false}
              handleStyle={{
                borderColor: 'white',
                height: 35,
                width: 35,
                marginTop: -8,
                backgroundColor: '#81C3D0'
              }}
              railStyle={{ backgroundColor: '#E6F8FB', height: 20 }}
              dots={false}
            />
          </div>

          <div className="col-md-2 no-padding" />
        </div>

        <br /><br /><br /><br /><br />

        <div className="navigation-buttons no-colour mt-20">
          <div className="back">
            <Button
              className="navigation-button"
              onClick={() => handleButtonClick(true)}
            >
              ← Back
            </Button>
          </div>
          {(valid || skipValidation) &&
            <div className="next">
              <Button
                className="navigation-button"
                onClick={() => handleButtonClick()}
              >
                Next →
              </Button>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default PageSixPers;
